import React from "react";
import { connect } from "react-redux";

import { Column } from "devextreme-react/ui/data-grid";
import { Button, DataGrid, ValidationGroup, TextArea, Accordion, Popover, List, SelectBox } from "devextreme-react";

import { nextStep,
  setDataSolicitudAgenda,
  changeExamenesAdicionales,
  changeExamenesPsicologicos,
  setDefaultCityId,
  setPoolsUpdate,
  setExamsUpdate,
  setHeadersUpdate,
  setSelectedCenter,
  openCloseModalEliminarExamen } from "../../actions";
import { openCloseToast } from "../../../../../../Global/actions";
import TextField from "../../../../../../Shared/fields/TextField";
import SelectField from "../../../../../../Shared/fields/SelectField";
import DateField from "../../../../../../Shared/fields/DateField";
import TableTabs from "../../../../../../Shared/tableTabs";
import ModalEliminarExamen from "../../modalEliminarExamen";
import moment from "moment";

class SolicitudExamen extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      withShadingOptionsVisible: false,
      contentPopover: [],
      indexTable: 0,
      disableBateryTab: false,
      disableExamsTab: false,
      disablePsicoTab: false,
    };
    this.showWithShadingOptions = this.showWithShadingOptions.bind(this);
    this.hideWithShadingOptions = this.hideWithShadingOptions.bind(this);
  }

  getDefaultCity(c) {
    const _city = c.map((e, i) => e.selected ? e.Id : null).filter((f) => f);
    return _city[0] ? _city[0] : null;
  }

  handleChange = (e, elementId) => {
    const _data = { ...this.props.dataSolicitudAgendaSel };
    const { listaSolicitantes } = this.props;
    const _selectOffice = (officeList, idCity) => {
      const data = officeList.map((c) => {
        c.selected = c.Id === idCity;
        return c;
      });
      return data;
    };
    const _selectCentro = (list, id, idCity) => {
      if (!this.props.defaultCityId) {
        //this.setState({ disableExamsTab: false, disablePsicoTab: false, disableBateryTab: false });
        this.props.dispatch(setDefaultCityId(idCity));
      }
      if (!id) return list;
      return list.map((b) => {
        if (b.Id.toString() === id) { b.AchsOffices = _selectOffice(b.AchsOffices, idCity); }
        return b;
      });
    };

    const _validateListExams = (list) => {
      return [...list, e.itemData]
      let _return = [];
      if (_data.baterias.length === 0 && _data.examenesAdicionales.length === 0 && _data.examenesPsicologicos.length === 0 && !this.props.defaultCityId) {
        _return = [...list, e.itemData];
      } else if (this.props.defaultCityId) {
        e.itemData.AchsOffices = _selectOffice(e.itemData.AchsOffices, this.props.defaultCityId);
        _return = [...list, e.itemData];
      } else {
        this.showToastr("Debe indicar la ciudad o agencia, para poder agregar un nuevo elemento", "error");
      }

      return _return;
    };

    if (e.element.id.includes("ciudadSelected")) {
      const _split_name = e.element.id.split("_");
      const _typeCity = _split_name[1] ? _split_name[1] : null;
      switch (_typeCity) {
        case "baterias": {
          //if (this.props.dataSolicitudAgendaSel && !this.props.isPoolsUpdate) this.props.dispatch(setPoolsUpdate(true));
          //_data.baterias = _selectCentro([..._data.baterias], (_split_name[2] ? _split_name[2] : null), e.value);
          break;
        }
        case "psicologicos": {
         // if (this.props.dataSolicitudAgendaSel && !this.props.isExamsUpdate) this.props.dispatch(setExamsUpdate(true));
          //_data.examenesPsicologicos = _selectCentro([..._data.examenesPsicologicos], (_split_name[2] ? _split_name[2] : null), e.value);
          break;
        }
        case "adicionales": {
          //if (this.props.dataSolicitudAgendaSel && !this.props.isExamsUpdate) this.props.dispatch(setExamsUpdate(true));
          //_data.examenesAdicionales = _selectCentro([..._data.examenesAdicionales], (_split_name[2] ? _split_name[2] : null), e.value);
          break;
        }
        default:
      }
    } else {
      switch (e.element.id) {
        case "solicitante": {
          if (this.props.dataSolicitudAgendaSel && !this.props.isRequestHeaderUpdate) this.props.dispatch(setHeadersUpdate(true));
          _data.solicitante = e.value;
          const aprobador = listaSolicitantes && listaSolicitantes.length ? listaSolicitantes.find((x) => x.Rut === e.value) : null;
          _data.nombreAprobador = aprobador && aprobador.EmployeeName ? aprobador.EmployeeName : null;
          break;
        }
        case "centroCostos": {
          if (this.props.dataSolicitudAgendaSel && !this.props.isRequestHeaderUpdate) this.props.dispatch(setHeadersUpdate(true));
          _data.centroCostos = e.value;
          break;
        }
        case "cargo": {
          if (this.props.dataSolicitudAgendaSel && !this.props.isRequestHeaderUpdate) this.props.dispatch(setHeadersUpdate(true));
          if (e.value === 0) {
            _data.showOtroCargo = true;
          } else {
            _data.showOtroCargo = false;
            _data.otroCargo = null;
          }
          _data.cargo = e.value;

          break;
        }
        case "otroCargo": {
          if (this.props.dataSolicitudAgendaSel && !this.props.isRequestHeaderUpdate) this.props.dispatch(setHeadersUpdate(true));
          _data.otroCargo = e.value;
          break;
        }
        case "tipoEvaluacion": {
          if (this.props.dataSolicitudAgendaSel && !this.props.isRequestHeaderUpdate) this.props.dispatch(setHeadersUpdate(true));
          _data.tipoEvaluacion = e.value;
          break;
        }
        case "baterias": {
          //if (!this.props.defaultCityId) {
            //this.setState({ disableExamsTab: true, disablePsicoTab: true, disableBateryTab: false });
            //this.showToastr("Debe indicar la ciudad o agencia, para poder agregar un nuevo elemento", "info");
          //}
          if (this.props.dataSolicitudAgendaSel && !this.props.isPoolsUpdate) this.props.dispatch(setPoolsUpdate(true));
          _data.baterias = _validateListExams(_data.baterias);
          break;
        }
        case "fechaReferencia": {
          if (this.props.dataSolicitudAgendaSel && !this.props.isRequestHeaderUpdate) this.props.dispatch(setHeadersUpdate(true));
          _data.fechaReferencia = e.value;
          break;
        }
        case "fechaReferenciaEnd": {
          if (this.props.dataSolicitudAgendaSel && !this.props.isRequestHeaderUpdate) this.props.dispatch(setHeadersUpdate(true));
          _data.fechaReferenciaEnd = e.value;
          break;
        }
        case "observaciones": {
          if (this.props.dataSolicitudAgendaSel && !this.props.isRequestHeaderUpdate) this.props.dispatch(setHeadersUpdate(true));
          _data.observaciones = e.value;
          break;
        }
        case "examenesAdicionales": {
          //if (!this.props.defaultCityId) {
            //this.setState({ disableExamsTab: false, disablePsicoTab: true, disableBateryTab: true });
            //this.showToastr("Debe indicar la ciudad o agencia, para poder agregar un nuevo elemento", "info");
          //}
          if (this.props.dataSolicitudAgendaSel && !this.props.isExamsUpdate) this.props.dispatch(setExamsUpdate(true));
          _data.examenesAdicionales = _validateListExams(_data.examenesAdicionales);
          break;
        }
        case "examenesPsicologicos": {
          //if (!this.props.defaultCityId) {
           // this.setState({ disableExamsTab: true, disablePsicoTab: false, disableBateryTab: true });
             //this.showToastr("Debe indicar la ciudad o agencia, para poder agregar un nuevo elemento", "info");
          //}
          if (this.props.dataSolicitudAgendaSel && !this.props.isExamsUpdate) this.props.dispatch(setExamsUpdate(true));
          _data.examenesPsicologicos = _validateListExams(_data.examenesPsicologicos);
          break;
        }
        default:
      }
    }
    this.props.onSave();
    this.props.dispatch(setDataSolicitudAgenda(_data));
  }

  handleChangeExamenesAdicionales = (e) => this.props.dispatch(changeExamenesAdicionales(e.value));

  handleChangeExamenesPsicologicos = (e) => this.props.dispatch(changeExamenesPsicologicos(e.value));

  handleSave = () => this.props.dispatch(nextStep());

  openModalPendientes = () => this.setState({ openModalPendientes: true });

  handleCerrarPendientes = () => this.setState({ openModalPendientes: false });

  handleNextStep = (params) => {
    const result = params.validationGroup.validate();
    //const inputCityNoValid = result.brokenRules.filter((e) => !e.isValid && e.validator._$element[0].id && e.validator._$element[0].id.includes("ciudadSelected"));
    const _listExamsPools = [...this.props.dataSolicitudAgendaSel.baterias, ...this.props.dataSolicitudAgendaSel.examenesAdicionales, ...this.props.dataSolicitudAgendaSel.examenesPsicologicos];
    /*const noCitySelected = _listExamsPools.map((e) => e.AchsOffices.map((ee) => ee.selected && ee.selected === true).filter((f) => f));
    const sinCentro = noCitySelected.some((x) => x.length === 0);
    */if (_listExamsPools.length === 0) {
      this.showToastr("Debe seleccionar al menos una batería, un examen adicional o un examen psicológico.", "error");
    } /*else if ((inputCityNoValid && inputCityNoValid.length > 0) || (noCitySelected && noCitySelected[0] && noCitySelected[0].length === 0) || sinCentro) {
      this.showToastr("Debe indicar la ciudad o agencia de la Bateria, Exámen adicional, o examen Psicológico", "error");
    }*/ else if (result.isValid) {
      this.props.dispatch(nextStep());
    }
  }

  showToastr = (msg, type) => this.props.dispatch(openCloseToast({
    isToastOpen: true,
    msgToast: msg,
    typeStyle: type,
    displayTime: 5000,
  }));

  CustomItem = (data, tipo) => (
    <div id={`titleTooltip_${data.Id}`}>
      <SelectField
        label="Ciudad o agencia de la evaluación"
        displayExpr="Description"
        valueExpr="Id"
        dataSource={data.AchsOffices}
        searchEnabled
        id={`ciudadSelected_${tipo}_${data.Id}`}
        value={this.getDefaultCity(data.AchsOffices)}
        onValueChanged={(value) => this.handleChange(value, data.Id)}
      />
    </div>
  );

  removeExamen = (e, d, t) => {
    e.event.stopPropagation();
    const _data = { ...this.props.dataSolicitudAgendaSel };

    switch (t) {
      case "bateria": {
        _data.baterias = _data.baterias.filter((v) => v.Id !== d.Id);
        break;
      }
      case "adicional": {
        _data.examenesAdicionales = _data.examenesAdicionales.filter((v) => v.Id !== d.Id);
        break;
      }
      case "psicologico": {
        _data.examenesPsicologicos = _data.examenesPsicologicos.filter((v) => v.Id !== d.Id);
        break;
      }
      default:
    }
    this.props.dispatch(setDataSolicitudAgenda(_data))
  }

  showWithShadingOptions = () => this.setState({ withShadingOptionsVisible: true });

  hideWithShadingOptions = () => this.setState({ withShadingOptionsVisible: false });

  handleTabChange = (index) => {
    this.setState({ indexTable: index });
  }

  contentTabBatery = () => {
    let listaBateriasFiltrada = [];
    if (!this.props.dataSolicitudAgendaSel.baterias.length) {
      listaBateriasFiltrada = this.props.listaBaterias.filter(e => e.AchsOffices.find(ee => this.props.centroSeleccionado === ee.Id))
    } else {
      listaBateriasFiltrada = this.props.listaBaterias.filter((i) => i.AchsOffices.find(ee => this.props.centroSeleccionado === ee.Id) && this.props.dataSolicitudAgendaSel.baterias.every((b) => b.Id !== i.Id));
    }
    const _attrDataPopOver = (data) => {
      const _return = {
        dataSource: data,
        showBorders: true,
        showRowLines: true,
        allowColumnResizing: true,
        columnAutoWidth: true,
        columnMinWidth: 50,
        rowAlternationEnabled: true,
        hoverStateEnabled: false,
        activeStateEnabled: false,
        focusStateEnabled: false,
      };
      if (data.length > 8) { _return.height = 450; }
      return _return;
    };
    return (<div style={{ marginTop: 10 }}>
      <div className="row">
        <div className="col-12">
          <SelectField
            styleRoot={{ marginTop: 0, marginBottom: 10 }}
            validation={false}
            label="Batería de exámenes"
            displayExpr="Description"
            valueExpr="Id"
            dataSource={listaBateriasFiltrada}
            searchEnabled
            id="baterias"
            noDataText={this.props.centroSeleccionado ? "No existen prestaciones para el centro seleccionado" : "Seleccione un centro"}
            onItemClick={this.handleChange}
            value={this.props.dataSolicitudAgendaSel.baterias.length > 0 ? this.props.dataSolicitudAgendaSel.baterias[this.props.dataSolicitudAgendaSel.baterias.length - 1].Id : null}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <List
            noDataText=""
            activeStateEnabled={false}
            focusStateEnabled={false}
            hoverStateEnabled={false}
            id="acordion_bateria"
            className={this.props.dataSolicitudAgendaSel.baterias && this.props.dataSolicitudAgendaSel.baterias.length > 0 ? "accordion bateria" : "accordion"}
            dataSource={this.props.dataSolicitudAgendaSel.baterias}
            itemRender={(data) => (<div className="titleContent">
            <h4>{data.Description}</h4>
            <Button icon="close" stylingMode="text" onClick={(e) => this.removeExamen(e, data, "bateria")} />
            <Button
              icon="help"
              stylingMode="text"
              onClick={(e) => {
                this.setState({ contentPopover: data.ExamsDetails }, () => {
                  e.event.preventDefault();
                  this.showWithShadingOptions(e);
                });
              }}
            />
          </div>)} />
          <Popover
            className="popoverBateria"
            target="#acordion_bateria"
            position="right"
            height="auto"
            visible={this.state.withShadingOptionsVisible}
            onHiding={this.hideWithShadingOptions}
          >
            <DataGrid
              {..._attrDataPopOver(this.state.contentPopover)}
            >
              <Column
                caption="Exámenes"
                dataField="Description"
                allowResizing
              />
            </DataGrid>
          </Popover>
        </div>
      </div>
    </div>);
  }

  contentTabExams = () => {
    let listaExamenesFiltrada = [];
    if (!this.props.dataSolicitudAgendaSel.examenesAdicionales.length) {
      listaExamenesFiltrada = this.props.listaExamenes.filter(e => e.AchsOffices.find(ee => this.props.centroSeleccionado === ee.Id));
    } else {
      listaExamenesFiltrada = this.props.listaExamenes.filter((i) => i.AchsOffices.find(ee => this.props.centroSeleccionado === ee.Id) && this.props.dataSolicitudAgendaSel.examenesAdicionales.every((b) => b.Id !== i.Id));
    }
    return (<div style={{ marginTop: 10 }}>
      <div className="row">
        <div className="col-12">
          <SelectField
            styleRoot={{ marginTop: 0, marginBottom: 10 }}
            label="Prestaciones médicas"
            validation={false}
            displayExpr="Description"
            valueExpr="Id"
            dataSource={listaExamenesFiltrada}
            searchEnabled
            id="examenesAdicionales"
            noDataText={this.props.centroSeleccionado ? "No existen prestaciones para el centro seleccionado" : "Seleccione un centro"}
            onItemClick={this.handleChange}
            value={this.props.dataSolicitudAgendaSel.examenesAdicionales.length > 0 ? this.props.dataSolicitudAgendaSel.examenesAdicionales[this.props.dataSolicitudAgendaSel.examenesAdicionales.length - 1].Id : null}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <List
            noDataText=""
            activeStateEnabled={false}
            focusStateEnabled={false}
            hoverStateEnabled={false}
            id="acordion_bateria"
            className={this.props.dataSolicitudAgendaSel.examenesAdicionales && this.props.dataSolicitudAgendaSel.examenesAdicionales.length > 0 ? "accordion adicional" : "accordion"}
            dataSource={this.props.dataSolicitudAgendaSel.examenesAdicionales}
            itemRender={(data) => (<div className="titleContent">
            <h4>{data.Description}</h4>
            <Button icon="close" stylingMode="text" onClick={(e) => this.removeExamen(e, data, "adicional")} />
          </div>)} />
        </div>
      </div>
    </div>);
  }

  contentTabPsico = () => {
    let listaExamenesPsicologicosFiltrada = [];
    if (!this.props.dataSolicitudAgendaSel.examenesPsicologicos.length) {
      listaExamenesPsicologicosFiltrada = this.props.listaExamenesPsicologicos.filter(e => e.AchsOffices.find(ee => this.props.centroSeleccionado === ee.Id));
    } else {
      listaExamenesPsicologicosFiltrada = this.props.listaExamenesPsicologicos.filter((i) => i.AchsOffices.find(ee => this.props.centroSeleccionado === ee.Id) && this.props.dataSolicitudAgendaSel.examenesPsicologicos.every((b) => b.Id !== i.Id));
    }
    return (<div style={{ marginTop: 10 }}>
      <div className="row">
        <div className="col-12">
          <SelectField
            styleRoot={{ marginTop: 0, marginBottom: 10 }}
            label="Evaluación  psicológica"
            displayExpr="Description"
            valueExpr="Id"
            dataSource={listaExamenesPsicologicosFiltrada}
            searchEnabled
            validation={false}
            id="examenesPsicologicos"
            noDataText={this.props.centroSeleccionado ? "No existen prestaciones para el centro seleccionado" : "Seleccione un centro"}
            onItemClick={this.handleChange}
            value={this.props.dataSolicitudAgendaSel.examenesPsicologicos.length > 0 ? this.props.dataSolicitudAgendaSel.examenesPsicologicos[this.props.dataSolicitudAgendaSel.examenesPsicologicos.length - 1].Id : null}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <List
            noDataText=""
            activeStateEnabled={false}
            focusStateEnabled={false}
            hoverStateEnabled={false}
            id="acordion_bateria"
            className={this.props.dataSolicitudAgendaSel.examenesPsicologicos && this.props.dataSolicitudAgendaSel.examenesPsicologicos.length > 0 ? "accordion adicional" : "accordion"}
            dataSource={this.props.dataSolicitudAgendaSel.examenesPsicologicos}
            itemRender={(data) => (<div className="titleContent">
            <h4>{data.Description}</h4>
            <Button icon="close" stylingMode="text" onClick={(e) => this.removeExamen(e, data, "adicional")} />
          </div>)} />
        </div>
      </div>
    </div>);
  }

  handleCenterSelected = (e) => {
    const _data = { ...this.props.dataSolicitudAgendaSel };
    let _baterias = _data.baterias ? _data.baterias.filter(e => e.AchsOffices.find(ee => ee.Id === e.value)) : [];
    let _exam = _data.examenesAdicionales ? _data.examenesAdicionales.filter(e => e.AchsOffices.find(ee => ee.Id === e.value)) : [];
    let _psic = _data.examenesPsicologicos ? _data.examenesAdicionales.filter(e => e.AchsOffices.find(ee => ee.Id === e.value)) : [];
    _data.baterias = _baterias;
    _data.examenesAdicionales = _exam;
    _data.examenesPsicologicos = _psic;
    this.props.dispatch(setSelectedCenter(e.value))
    this.props.onSave();
    this.props.dispatch(setDataSolicitudAgenda(_data));
  }

  render() {
    const {
      dataSolicitudAgendaSel,
      listaCargos,
    } = this.props;
    return (
      <React.Fragment>
        <ModalEliminarExamen />
        <ValidationGroup className="row solicitudExamen" style={{ maxWidth: 700 }} >
          <div className="col-12">
            <div className="row">
              <div className="col-12">
                <h4 className="newDenuncia-subtitle">Datos del aprobador</h4>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <SelectField
                  label="Aprobador"
                  displayExpr="displaySelect"
                  valueExpr="Rut"
                  dataSource={this.props.listaSolicitantes}
                  searchEnabled
                  id="solicitante"
                  onValueChanged={this.handleChange}
                  value={this.props.dataSolicitudAgendaSel.solicitante ? this.props.dataSolicitudAgendaSel.solicitante : ""}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <TextField
                  id="centroCostos"
                  maxLength={80}
                  label="Centro de costos"
                  onChange={this.handleChange}
                  value={this.props.dataSolicitudAgendaSel.centroCostos ? this.props.dataSolicitudAgendaSel.centroCostos : ""}
                />
              </div>
              <div className="col-12">
                <h3><p><span className="important-message">*El centro de costos debe ser ingresado correctamente para poder asignar el cobro</span></p></h3>
              </div>
            </div>
            <div className="row" style={{ marginTop: 15 }}>
              <div className="col-12">
                <h4 className="newDenuncia-subtitle">Solicitud de exámenes</h4>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <SelectField
                  styleRoot={{ marginTop: 0 }}
                  label="Cargo"
                  displayExpr="Description"
                  valueExpr="Id"
                  dataSource={listaCargos}
                  searchEnabled
                  id="cargo"
                  onValueChanged={this.handleChange}
                  value={dataSolicitudAgendaSel.cargo != null ? dataSolicitudAgendaSel.cargo : ""}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                { dataSolicitudAgendaSel.showOtroCargo || !!dataSolicitudAgendaSel.otroCargo || dataSolicitudAgendaSel.cargo === 0 ?
                  <TextField
                    id="otroCargo"
                    maxLength={100}
                    label="Especifica otro cargo"
                    onChange={this.handleChange}
                    value={dataSolicitudAgendaSel.otroCargo ? dataSolicitudAgendaSel.otroCargo : ""}
                  /> : <div />}
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <SelectField
                  label="Tipo de evaluación"
                  displayExpr="Description"
                  valueExpr="Id"
                  dataSource={this.props.listaTipoExamenes}
                  id="tipoEvaluacion"
                  onValueChanged={this.handleChange}
                  value={this.props.dataSolicitudAgendaSel.tipoEvaluacion ? this.props.dataSolicitudAgendaSel.tipoEvaluacion : ""}
                />
              </div>
              {/*<div className="col-12">
                <h3><p><span className="important-message">*El tipo de evaluación ingresado es referencial, será corroborado con el listado de trabajadores</span></p></h3>
                </div>*/}
            </div>
            <div className="row" style={{ marginTop: 15 }}>
              <div className="col-12">
                <h3 className=""><p>Ingresa un rango de fecha. </p></h3>
              </div>
              <div className="col-6">
                <DateField
                  styleRoot={{ marginTop: 0 }}
                  label="Fecha inicio"
                  id="fechaReferencia"
                  onChange={this.handleChange}
                  type="date"
                  min={(this.props.dataSolicitudAgendaSel.fechaReferencia && this.props.dataSolicitudAgendaSel.fechaReferencia < new Date())? moment(this.props.dataSolicitudAgendaSel.fechaReferencia).format() : new Date()}
                  max={this.props.dataSolicitudAgendaSel.fechaReferenciaEnd ? moment(this.props.dataSolicitudAgendaSel.fechaReferenciaEnd).format() : new Date().setFullYear(3000)}
                  value={this.props.dataSolicitudAgendaSel.fechaReferencia ? this.props.dataSolicitudAgendaSel.fechaReferencia : ""}
                />
              </div>
              <div className="col-6">
                <DateField
                  styleRoot={{ marginTop: 0 }}
                  label="Fecha fin"
                  id="fechaReferenciaEnd"
                  onChange={this.handleChange}
                  type="date"
                  min={this.props.dataSolicitudAgendaSel.fechaReferencia ? moment(this.props.dataSolicitudAgendaSel.fechaReferencia).format() : new Date()}
                  max={new Date().setFullYear(3000)}
                  value={this.props.dataSolicitudAgendaSel.fechaReferenciaEnd ? this.props.dataSolicitudAgendaSel.fechaReferenciaEnd : ""}
                />
              </div>
              <div className="col-12">
                <h3><p><span className="important-message">*La fecha es referencial y está sujeta a la disponibilidad de agenda</span></p></h3>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <SelectField
                  label="Centro de atención"
                  Id="centros"
                  searchEnabled
                  placeholder="Listado de Centros"
                  value={this.props.centroSeleccionado}
                  dataSource={this.props.listaCentros}
                  displayExpr="Description"
                  valueExpr="Id"
                  onValueChanged={this.handleCenterSelected}
                />
              </div>
            </div>
            <div className="row" style={{ marginTop: 15 }}>
              <div className="col-12">
                <TableTabs
                // selectedSiniestro={this.props.selectedSiniestro}
                  index={this.state.indexTable}
                  changeTabCallback={this.handleTabChange}
                  scrollByContent
                  showNavButtons={false}
                  tabs={[
                    {
                      //disabled: this.state.disableBateryTab,
                      contentId: 0,
                      index: 0,
                      Name: "Baterías",
                      Number: this.props.dataSolicitudAgendaSel && this.props.dataSolicitudAgendaSel.baterias ? this.props.dataSolicitudAgendaSel.baterias.filter(e => e.AchsOffices.find(ee => this.props.centroSeleccionado === ee.Id)).length : 0,
                    },
                    {
                      //disabled: this.state.disableExamsTab,
                      contentId: 1,
                      index: 1,
                      Name: "Prestaciones médicas",
                      Number: this.props.dataSolicitudAgendaSel && this.props.dataSolicitudAgendaSel.examenesAdicionales ? this.props.dataSolicitudAgendaSel.examenesAdicionales.filter(e => e.AchsOffices.find(ee => this.props.centroSeleccionado === ee.Id)).length : 0,
                    },
                    {
                      //disabled: this.state.disablePsicoTab,
                      contentId: 2,
                      index: 2,
                      Name: "Evaluaciones psicológicas",
                      Number: this.props.dataSolicitudAgendaSel && this.props.dataSolicitudAgendaSel.examenesPsicologicos ? this.props.dataSolicitudAgendaSel.examenesPsicologicos.filter(e => e.AchsOffices.find(ee => this.props.centroSeleccionado === ee.Id)).length : 0,
                    },
                  ]}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                {this.state.indexTable === 0 && this.contentTabBatery()}
                {this.state.indexTable === 1 && this.contentTabExams()}
                {this.state.indexTable === 2 && this.contentTabPsico()}
              </div>
            </div>
            {this.props.dataSolicitudAgendaSel.baterias && this.props.dataSolicitudAgendaSel.baterias.length > 0 && this.props.dataSolicitudAgendaSel.baterias.find(e => e.Id === 12) ?
            <div className="row">
              <div className="col-12">
                <TextArea
                  className={"warningSelectedBatery"}
                  stylingMode={"filled"}
                  readOnly
                  activeStateEnabled={false}
                  focusStateEnabled={false}
                  hoverStateEnabled={false}
                  defaultValue={'Para la batería "Altitud Geográfica" indica en las observaciones la faena minera donde se ubica o ubicará el trabajador'}
                  width={'100%'}
                  placeholder={'Details'}
                />
              </div>
            </div> : ""}
            <div className="row">
              <div className="col-12">
                <TextArea
                  id="observaciones"
                  className="observaciones"
                  placeholder="Observaciones"
                  maxLength={200}
                  height={100}
                  onValueChanged={this.handleChange}
                  valueChangeEvent="focusout"
                  value={this.props.dataSolicitudAgendaSel.observaciones ? this.props.dataSolicitudAgendaSel.observaciones : ""}
                />
              </div>
            </div>


            <div className="row">
              <div className="col-12">
                <Button
                  text="Siguiente"
                  type="success"
                  className="newSolicitud-next-button"
                  onClick={this.handleNextStep}
                  useSubmitBehavior
                />
              </div>
            </div>
          </div>
        </ValidationGroup>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  jsonData: state.solicitudesAgendaSel.jsonData,
  companyId: state.global.companyId,
  pendingComplaints: state.solicitudesAgendaSel.pendingComplaints,
  disableContinueNewComplaint: state.solicitudesAgendaSel.disableContinueNewComplaint,
  listaSolicitantes: state.solicitudesAgendaSel.listaSolicitantes,
  listaCargos: state.solicitudesAgendaSel.listaCargos,
  listaBaterias: state.solicitudesAgendaSel.listaBaterias,
  listaExamenes: state.solicitudesAgendaSel.listaExamenes,
  listaExamenesPsicologicos: state.solicitudesAgendaSel.listaExamenesPsicologicos,
  listaTipoExamenes: state.solicitudesAgendaSel.listaTipoExamenes,
  listaCentros: state.solicitudesAgendaSel.listaCentros,
  centroSeleccionado: state.solicitudesAgendaSel.centroSeleccionado,
  examenesPsicologicos: state.solicitudesAgendaSel.examenesPsicologicos,
  examenesAdicionales: state.solicitudesAgendaSel.examenesAdicionales,
  dataSolicitudAgendaSel: state.solicitudesAgendaSel.dataSolicitudAgendaSel,
  defaultCityId: state.solicitudesAgendaSel.defaultCityId,
  isPoolsUpdate: state.solicitudesAgendaSel.isPoolsUpdate,
  isExamsUpdate: state.solicitudesAgendaSel.isExamsUpdate,
  isRequestHeaderUpdate: state.solicitudesAgendaSel.isRequestHeaderUpdate,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
  onOpenModal: (open, data, examen) => dispatch(openCloseModalEliminarExamen(open, data, examen)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SolicitudExamen);
